import { useState } from 'react';
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../store/hooks';
import { requestPasswordResetThunk } from '../../store/user/userThunks';

export interface ResetModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
}

export default function ResetModal({ isOpen, onOpenChange }: ResetModalProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [usrname, setUsrname] = useState('');

  const resetPassword = async () => {
    const success = await dispatch(
      requestPasswordResetThunk({ username: usrname })
    );
    if (success) {
      navigate(`/reset-password?username=${encodeURIComponent(usrname)}`);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="sm"
      backdrop="blur"
      scrollBehavior="inside"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader>Password Reset</ModalHeader>
            <ModalBody className="reset-body-modal">
              <Input
                label="Email"
                value={usrname}
                onChange={(e) => setUsrname(e.target.value)}
              />
              <p className="text-sm text-default-500">
                We will send a reset code to this email, then open the password
                reset page.
              </p>
            </ModalBody>
            <ModalFooter className="reset-footer-modal">
              <Button
                onPress={async () => {
                  await resetPassword();
                  onClose();
                }}
              >
                Confirm
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
